<template>
  <div class="container-custom">
    <!-- Breadcrumbs -->
    <Breadscrumbs
      :links="[
        {
          name: 'Products',
          to: {
            name: 'Products'
          }
        },
        {
          name: 'Edit',
          to: {
            name: 'ProductInfoEdit',
            params: {
              id: $route.params.id
            }
          }
        }
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯產品資訊</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>
    <!--  -->
    <ProductInfoEditCreate></ProductInfoEditCreate>
    <!-- page-actions -->
    <div class="page-actions">
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import ProductInfoEditCreate from '@/views/C-3__Products/c/ProductInfoEditCreate.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    Breadscrumbs,
    ProductInfoEditCreate,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
  }),
  async created() {
    if (this.$route.params.id) {
      await this.getProduct(this.$route.params.id);
    }
  },
  computed: {
    ...mapGetters(['lang']),
    ...mapState('product', ['product']),
  },
  methods: {
    ...mapActions('product', {
      getProduct: 'findById',
      save: 'save',
      clear: 'clear',
    }),
    cancelHandler() {
      this.clear();
      this.$router.push({ name: 'Products' });
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.save(this.product).then(() => {
          this.clear();
          this.$router.push({ name: 'Products' });
        });
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
